import {AbstractModel} from '../abstract-model';

export class AffiliateUser extends AbstractModel {
  id: number | null = null;
  email: string | null = null;
  phoneNumber: string | null = null;
  enabled: boolean = true;
}
